import { render, staticRenderFns } from "./ResearchesPage.vue?vue&type=template&id=7db5505f&scoped=true"
import script from "./ResearchesPage.vue?vue&type=script&lang=js"
export * from "./ResearchesPage.vue?vue&type=script&lang=js"
import style0 from "./ResearchesPage.vue?vue&type=style&index=0&id=7db5505f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db5505f",
  null
  
)

export default component.exports